<template>
  <div class="main-content">
    <div ref="qrmodal" class="modal" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content" style="background: white;">
          <div class="modal-body" style="background-color:white">
            <div id="qrmodal-body">
              <Richtext v-if="qrcodeMode=='EDIT'" v-model="formData.header_text"/>
              <template v-if="qrcodeMode=='PREVIEW'"><div v-html="formData.header_text"></div></template>

              <div class="div-center">
                <img :src="'data:image/png;base64,' +qrcode" width="400" />
              </div>
              <Richtext v-if="qrcodeMode=='EDIT'" v-model="formData.content_text"/>
              <br/>
              <template v-if="qrcodeMode=='PREVIEW'"><div v-html="formData.content_text"></div></template>

              <div class="row" style="align-items: flex-end">
                <div class="col-sm-8">
                  <!-- <h5 style="padding-top:36px">{{$helper.getWord('qr_code_description')}}</h5> -->
                  <img height="40" src="/static/img/app-store.svg" />
                  <img style="padding-left:10px" height="40" src="/static/img/play-store.svg" />
                </div>
                <div class="col-sm-4">
                  <img height="100" src="/static/img/logo_v2.png" style="float:right" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" v-if="qrcodeMode=='EDIT'" @click="saveQrClicked()">SAVE</button>
            <button type="button" class="btn btn-primary" v-if="qrcodeMode=='PREVIEW'" @click="qrcodeMode='EDIT'">BACK</button>
            <button type="button" class="btn btn-primary" v-if="qrcodeMode=='EDIT'" @click="qrcodeMode='PREVIEW'">PREVIEW</button>
            <button type="button" class="btn btn-primary" v-if="qrcodeMode=='PREVIEW'" @click="generateQRCode(true)">PRINT</button>
          </div>
        </div>
      </div>
    </div>
    <section class="section">
      <PageHeaderNoAction :isShow="isShow" :page="this">
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="generateQRCode()"
              v-if="id"
            >
              <i class="far fa-save mr-2"></i>
              {{$helper.getWord('generate_qr')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save mr-2"></i>
              {{$helper.getWord('save')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>
              {{$helper.getWord('cancel')}}
            </button>
          </div>
        </template>
      </PageHeaderNoAction>
      <div class="section-body">
        <div class="card">
          <div class="card-header">
            <h4>{{$helper.getWord('Form Detail')}}</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <MobileTextbox
                :title="$helper.getWord('Form Name')+':'"
                wrapperclass="col-12 col-md-6"
                labelclass="col-12"
                inputclass="col-12"
                :className="'gstGroup'"
                v-model="formData.name"
                :readonly="isEdit"
              />
              <MobileTextbox
                :title="$helper.getWord('Access Code')+':'"
                wrapperclass="col-12 col-md-6"
                labelclass="col-12"
                inputclass="col-12"
                :className="'gstGroup'"
                v-model="formData.access_code"
                :readonly="isEdit"
              />
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <label class="col-form-label" :class="'col-12'">{{$helper.getWord('Description')}}:</label>
                  <div class="col-12">
                    <textarea
                      class="form-control"
                      v-model="formData.description"
                      rows="3"
                      style="min-height: 100px"
                      :readonly="isEdit"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h4>1. {{$helper.getWord('Choose Model')}}</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <fbselectbox2
                wrapperclass="col-12"
                :fboptions="[{ id:formData.mb_form_table_id , text: formData.mb_form_table_name}]"
                :fbhidelabel="true"
                :ajaxurl="'/api/model_builder/getModelBuilders'"
                v-model="formData.mb_form_table_id"
              />
            </div>
          </div>
        </div>
        <div
          class="card"
          v-if="formData.mb_form_table_id != null && formData.mb_form_table_id != undefined &&  formData.mb_form_table_id !='' && formData.mb_form_table_id != '00000000-0000-0000-0000-000000000000'"
        >
          <div class="card-header">
            <h4>2. {{$helper.getWord('Choose Form')}}</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <fbselectbox2
                wrapperclass="col-12"
                :fboptions="[{ id:formData.fb_form_code_id , text: formData.fb_form_code_table_name}]"
                :fbhidelabel="true"
                :ajaxurl="'/api/userBuildForm/getUserFormBuilders'"
                :ajaxparam="{ mb_form_table_id : formData.mb_form_table_id }"
                v-model="formData.fb_form_code_id"
                ref="formbuilderselect"
              />
            </div>
          </div>
        </div>
        <div
          class="card"
          v-if="formData.mb_form_table_id != null && formData.mb_form_table_id != undefined  &&  formData.mb_form_table_id !='' && formData.mb_form_table_id != '00000000-0000-0000-0000-000000000000'"
        >
          <div class="card-header">
            <h4>3. {{$helper.getWord('Choose WorkFlow')}}</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <fbselectbox2
                wrapperclass="col-12"
                :fboptions="[{ id:formData.workflow_name , text: formData.workflow_name}]"
                v-model="formData.workflow_name"
                :ajaxurl="'/api/workflow/getWorkflows'"
                :ajaxparam="{ mb_form_table_id : formData.mb_form_table_id }"
                :fbhidelabel="true"
                :key="componentkey"
                ref="workflowselect"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Submit Model-->
    <div
      id="wfDiagramModal"
      class="modal fade so-alert-dialog in"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg bootstrap-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div id="graph"></div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" data-dismiss="modal">{{$helper.getWord('OK')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!--Submit Model-->
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";
import config from "@/config";
import Richtext from "@/components/richtext";

export default {
  title: "isWork Form",
  access_code: "IWF_NEW03",
  hidden: true,
  components: {Richtext},
  data() {
    return {
      componentkey: 0,
      lookups: {},
      isShow: null,
      gridId: "form01",
      formData: {},
      ticon: false,
      isEdit: true,
      qrcode: null,
      qrcodeMode:"EDIT"
    };
  },
  created() {
    ////this.$route.meta.access_code = this.gridId;
    //helper.initFormGrid(this);
    if (window.innerWidth < window.innerHeight || window.innerWidth > 768) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  computed: {
    computedIcon() {
      if (this.icon == undefined) {
        return true;
      }

      return this.icon;
    },
    id() {
      return this.$route.params.id;
    }
  },
  updated() {
    if (window.innerWidth < window.innerHeight) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  watch: {
    "formData.mb_form_table_id": function(newval, oldval) {
      //console.log(newval);
      // this.$set(this.formData, 'form_builder_id', null)
      if (
        this.formData.mb_form_table_id != null &&
        this.formData.mb_form_table_id != undefined &&
        this.formData.mb_form_table_id != "" &&
        this.formData.mb_form_table_id != "00000000-0000-0000-0000-000000000000"
      ) {
        if (
          this.$refs.formbuilderselect != undefined &&
          this.$refs.formbuilderselect != null &&
          this.$refs.workflowselect != undefined &&
          this.$refs.workflowselect
        ) {
          this.formData.form_builder_id = null;
          this.formData.workflow_name = null;

          this.$refs.formbuilderselect.select2.val(null).trigger("change");
          this.$refs.workflowselect.select2.val(null).trigger("change");
        }
        // this.$set(this.formData, 'workflow_name', null)
      }
    }
  },
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest"
    ]),
    ...mapActions("filters", ["actionFindNow"]),
    cancelBtnClick() {
      this.$router.push("/isWorkForm/list");
    },
    generateQRCode(isDownload) {
      if (isDownload) {
        let vm = this;
        console.log($("#qrmodal-body").html());
        html2canvas($("#qrmodal-body"),{ scale: 5 }).then(function(canvas) {
          var a = document.createElement("a");
          a.href = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
          a.download = "qr_code" + ".png";
          a.click();
          helper.hideModal(vm.$refs.qrmodal);
        });

        // helper.capScreen($("#qrmodal-body"));
      }

      helper.loading();
      let link = `${config.serverURI}/#/public?ISWORK_ID=${this.id}&SUBSCRIPTION_ID=${this.formData.subscription_id}&ACCESS_CODE=${this.formData.access_code}`;

      api.request(
        this,
        "post",
        `/qrcode/getImage`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {
            link: link
          }
        },
        function(r) {
          this.qrcode = r.data.file;
          helper.showModal(this.$refs.qrmodal);

          helper.done();
        },
        function(r) {
          helper.done();
        }
      );
    },
    saveButtonClicked() {
      helper.loading();
      api.request(
        this,
        "post",
        `/isworkform/${this.gridId}_save`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {
            id: this.$route.params.id,
            formData: this.formData
          }
        },
        function(r) {
          // helper.clearData(this);
          // this.$router.go(-1);
          this.isEdit = true;
          this.$route.params.id = r.data.form_ID;
          helper.alert("OK");
        },
        function(r) {
          helper.done();
        }
      );
    },

    saveQrClicked() {
      helper.loading();
      api.request(
        this,
        "post",
        `/isworkform/save_qr_content`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {
            id: this.$route.params.id,
            formData: this.formData
          }
        },
        function(r) {
          // helper.clearData(this);
          // this.$router.go(-1);
          helper.done();
        },
        function(r) {
          helper.done();
        }
      );
    },
    loadForm() {
      helper.loading();
      api.request(
        this,
        "post",
        `/isworkform/${this.gridId}_load`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          //LocaleCode: this.$store.state.user.locale_code,
          Parameters: {
            id: this.$route.params.id
          }
        },
        function(r) {
          this.formData = r.data.formData;
          if (this.formData.id == "00000000-0000-0000-0000-000000000000") {
            this.isEdit = false;
          }
          helper.done();
        },
        function(r) {
          helper.done();
        },
        null
      );
    }
  },
  mounted() {
    this.loadForm();
  }
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}

.div-center {
  display: flex;
  justify-content: center;
}
</style>
